import { render, staticRenderFns } from "./MenuPackage.vue?vue&type=template&id=50811366&scoped=true&"
import script from "./MenuPackage.vue?vue&type=script&lang=js&"
export * from "./MenuPackage.vue?vue&type=script&lang=js&"
import style0 from "./MenuPackage.vue?vue&type=style&index=0&id=50811366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50811366",
  null
  
)

export default component.exports